import React, {useEffect, useState} from "react";
import Filter from "./Filter";
import FilterEvents from "./FilterEvents";
import {apiGetEntrancesForEvent} from "./Actions";
import DatatableApiPaginator from "../../components/datatable-api-paginator";

const ArenaEntrances = () => {
    const [loading, setLoading] = useState(false);
    const [subjectId, setSubjectId] = useState(null);
    const [eventId, setEventId] = useState(null);
    const [isExport, setIsExport] = useState(false);

    const [data, setData] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        if (eventId) fetchEntrances(page, perPage);
    }, [eventId, page, perPage]);

    const fetchEntrances = (page, perPage) => {
        setLoading(true);
        apiGetEntrancesForEvent(subjectId, eventId, page, perPage,isExport, (response) => {
            setData(response);
            setLoading(false);
        }, (err) => {
            console.error(err);
            setData(null);
            setLoading(false);
        });
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPerPage(newSize);
        setPage(1); // změna velikosti vždy resetuje stránku
    };

    const renderData = () => {
        if (loading) return <div>Loading...</div>;
        if (!data) return null;

        return (
            <DatatableApiPaginator
                data={data.data}
                columns={[
                    {Header: 'ID', accessor: 'id'},
                    {Header: 'Barcode', accessor: 'bc'},
                    {Header: 'Datum a čas', accessor: 'dateEntrance'},
                    {Header: 'Vstup/výstup', accessor: d => d.in === 1 ? "Vstup" : "Výstup"}
                ]}
                loading={loading}
                totalCount={data.total}
                pageSelectDefaultValue={perPage}
                defaultPage={page - 1} // react-table uses zero-index
                onPageChange={(pageIndex) => handlePageChange(pageIndex + 1)}
                onPageSelectChange={(size) => handlePageSizeChange(Number(size))}
            />
        );
    };

    return (
        <>
            <Filter onSubmit={(id) => setSubjectId(id)} loading={loading} disabled={eventId}/>
            <FilterEvents subjectId={subjectId} onSubmit={(values) => {
                setIsExport(values.isExcel)
                setEventId(values.eventId)
            }} loading={loading}/>
            {renderData()}
        </>
    );
};

export default ArenaEntrances;
